import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"
import { omit } from "lib/omit"

export const updateAssetRegister = api(async function updateAssetRegister({
    registerId,
    name,
    description,
    removeAssets,
    updateAssets,
    cobieFiles,
    options,
}) {
    updateAssets = updateAssets
        ? updateAssets.map((asset) => ({
              ...omit(asset, "assetRegister", "code"),
              code: asset.code,
              picture: asset.picture ? asset.picture.documents.map("href") : undefined,
          }))
        : undefined
    return mutate(
        gql`
            mutation UpdateAssetRegister(
                $id: String!
                $name: String
                $description: String
                $removeAssets: [String!]
                $updateAssets: [AssetInput!]
                $cobieFiles: [String!]
                $options: JSONObject
            ) {
                updateAssetRegister(
                    id: $id
                    register: {
                        name: $name
                        description: $description
                        removeAssets: $removeAssets
                        updateAssets: $updateAssets
                        cobieFiles: $cobieFiles
                        options: $options
                    }
                )
            }
        `,
        {
            id: registerId,
            name,
            description,
            removeAssets,
            updateAssets,
            cobieFiles,
            options,
        },
        {
            returns: "updateAssetRegister",
        }
    )
})
